import { computed } from "vue";
import { useSharedState } from "composables/useSharedState";
import { mergeClassProp } from "@/runtime/style-engine/define-variants";
import type { ChatDividerProps } from "./chat.types";
import { chatDividerClasses } from "./chat.styles";

export interface UseChatDividerOptions {
  props: Readonly<ChatDividerProps>;
}

export const useChatDivider = (options: UseChatDividerOptions) => {
  const { props } = options;
  useSharedState(props);

  const baseCls = chatDividerClasses({});
  const classes = computed(() => mergeClassProp(baseCls, props.class));

  return { classes };
};
